import { useState, useEffect } from "react";

import Background from "Components/Atoms/Background/background";
import H2 from "Components/Atoms/H2/h2";
import InputRow from "../InputRow/inputRow";
import InputRowRadio from "../InputRowRadio/inputRowRadio";
import Button from "Components/Atoms/Button/button";
import Space from "Components/Atoms/Space/space";

import { ReactComponent as ModalX } from "Util/svg/modalX.svg";

import { useDispatch } from "react-redux";
import { modalToggle } from "Store/Slices/modal";

import { RadioForm, PutCategory } from "types/interface";
import { putCategoryApi } from "Apis/apis";
import LANG, { getLang } from "Util/lang";
import InputRowNumber from "../InputRow/inputRowNumber";

const BigCategoryFixModal = ({
  categoryCode,
  bigCategoryName,
  categoryState,
  onSubmit,
  cateOrder,
}: {
  categoryCode: number;
  bigCategoryName: string;
  categoryState: number;
  onSubmit: () => void;
  cateOrder: number;
}) => {
  const dispatch = useDispatch();

  const [bigName, setBigName] = useState(bigCategoryName);
  const [status, setStatus] = useState(categoryState);
  const [order, setOrder] = useState(cateOrder);

  const STATE_DATA: RadioForm[] = [
    { idx: 1, label: LANG[getLang()].waiting, id: "wait" },
    { idx: 0, label: LANG[getLang()].approval, id: "ok" },
  ];

  const putBigCategory = async () => {
    const body: PutCategory = {
      categoryName: bigName,
      state: status,
      order: order,
    };
    await putCategoryApi(body, categoryCode);
    alert("수정이 완료되었습니다.");
    onSubmit();
    dispatch(modalToggle(2));
  };
  const deleteBigCategory = async () => {
    const body: PutCategory = {
      categoryName: bigName,
      state: 2,
      order,
    };
    await putCategoryApi(body, categoryCode);
    alert("수정이 완료되었습니다.");
    onSubmit();
    dispatch(modalToggle(2));
  };
  useEffect(() => {
    setBigName(bigCategoryName);
    setStatus(categoryState);
    setOrder(cateOrder);
  }, [bigCategoryName]);

  return (
    <Background modalNum={2}>
      <div style={{ width: "640px" }} className="p-32 bg-f2f3f8">
        <div className="flex justify-between items-center">
          <H2 isPrimary={true} name="대 카테고리 수정" />

          <div
            className="inline-block cursor-pointer"
            onClick={() => dispatch(modalToggle(2))}
          >
            <ModalX />
          </div>
        </div>
        <Space y={20} />
        <InputRow
          id="service"
          name={LANG[getLang()].categoryName}
          value={bigName}
          setValue={setBigName}
        />
        <InputRowRadio
          data={STATE_DATA}
          name={LANG[getLang()].state}
          value={status}
          setValue={setStatus}
        />
        <InputRowNumber
          id="service"
          name="순서"
          value={order}
          setValue={setOrder}
        />
        <div className="flex justify-end mt-10">
          <Button
            onClick={deleteBigCategory}
            btnText={LANG[getLang()].delete}
            color="delete"
          />
          <Space x={10} />

          <Button
            onClick={() => dispatch(modalToggle(2))}
            btnText={LANG[getLang()].cancel}
          />
          <Space x={10} />
          <Button onClick={putBigCategory} btnText={LANG[getLang()].change} />
        </div>
      </div>
    </Background>
  );
};

export default BigCategoryFixModal;
